import { render } from "./FooterMobile.vue?vue&type=template&id=3732e46a&scoped=true"
import script from "./FooterMobile.vue?vue&type=script&lang=js"
export * from "./FooterMobile.vue?vue&type=script&lang=js"

import "./FooterMobile.vue?vue&type=style&index=0&id=3732e46a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3732e46a"]])

export default __exports__